import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.jsx';
import registerServiceWorker from './registerServiceWorker';

import './style/public.css'
ReactDOM.render(
    <App/>,
    document.getElementById('root')
);
// registerServiceWorker();




// WEBPACK FOOTER //
// ./src/index.js